import { useTranslation } from 'react-i18next'
import {
    Container,
    Grid
} from '@material-ui/core'
import { SimpleLoading, HeaderHLPure } from '../../pures'
import { ConversationList, SimpleCard, AdvancedSearchFilters } from '../../pures/dashboard'
import { DropDownList } from "@progress/kendo-react-dropdowns"

const HistoryView = (props) => {
    const { dataConversations, chatbotUrl, handleGetPaginatedConversation, isLoadingChangePage, isLoading, monthYearOptions, date, handleChangeDate, searchValue, handleSearchChange, advancedOpen, filterDraft, toggleAdvanced, handleFilterChange, handleToggleSentiment, statusCatalog, handleToggleHistoryStatus, usersCatalog, applyFilters, clearFilters } = props
    const { t } = useTranslation('clients-dashboard', { keyPrefix: 'historyScreen' })

    return (
        <div className={"dashboardView"}>
            <Container>
                {
                    isLoading ?
                        <div className='loading' style={{ marginTop: '20%' }}>
                            <SimpleLoading />
                        </div>
                        :
                        <Grid>
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    <HeaderHLPure title={t("title")} />
                                </Grid>
                                <Grid item xs={12} md={advancedOpen ? 12 : 2} style={{ marginTop: '20px'}}>
                                    <SimpleCard
                                        title={t('usagePeriod')}
                                    >
                                        {
                                            advancedOpen
                                                ?
                                                <AdvancedSearchFilters
                                                    t={t}
                                                    filterDraft={filterDraft}
                                                    handleFilterChange={handleFilterChange}
                                                    handleToggleSentiment={handleToggleSentiment}
                                                    statusCatalog={statusCatalog}
                                                    handleToggleHistoryStatus={handleToggleHistoryStatus}
                                                    usersCatalog={usersCatalog}
                                                    applyFilters={applyFilters}
                                                    clearFilters={clearFilters}
                                                />
                                                :
                                                <DropDownList
                                                    id='assistantTone'
                                                    name={'assistantTone'}
                                                    className="eticket-dropdown-field"
                                                    textField="text"
                                                    dataItemKey="value"
                                                    data={monthYearOptions}
                                                    value={monthYearOptions.find(option => option.value === date)}
                                                    onChange={handleChangeDate}
                                                />
                                        }
                                        <span className="advanced-search-toggle" onClick={toggleAdvanced}>
                                            {t(advancedOpen ? 'simpleSearch' : 'advancedSearch')}
                                        </span>
                                    </SimpleCard>
                                </Grid>
                                <ConversationList dataConversations={dataConversations} t={t} chatbotUrl={chatbotUrl} handleGetPaginatedConversation={handleGetPaginatedConversation} isLoadingChangePage={isLoadingChangePage} searchValue={searchValue} handleSearchChange={handleSearchChange} />
                            </Grid>
                        </Grid>
                }
            </Container >
        </div>
    )
}

export { HistoryView as default }